<template>
  <td>
    <button class="tab-but-doc" @click="sUploader">Загрузить</button>
    <div
      class="modal fade in show"
      v-if="showUploader"
      tabindex="-1"
      role="dialog"
    >
      <div class="window-doc" v-show="!showECP">
        <h3>ЗАГРУЗКА ДОКУМЕНТА</h3>
        <form
          action="#"
          @submit.prevent="submit"
          class="load-doc"
          style="padding-right: 20px"
        >
          <p>
            <label>Вид документа</label>
            <template v-for="doc in docs">
              <span v-if="doc.ID == typeIndex">{{
                stripTags(doc.UF_NAME)
              }}</span>
            </template>
            <select
              @change="bindChange"
              v-model="typeIndex"
              class="i-style i-style-sel"
              :disabled="true"
              v-show="false"
            >
              <option
                v-for="doc in docs"
                :value="doc.ID"
                :key="doc.ID"
                :selected="doc.ID == typeIndex"
                :class="
                  doc.FILE_INFO != undefined && doc.FILE_INFO.UF_IS_AKCEPT === 1
                    ? 'hide'
                    : ''
                "
                >{{ stripTags(doc.UF_NAME) }}
              </option>
            </select>
          </p>
          <label v-show="false">Документ</label>
          <div class="file-upload" v-if="fileName">
            <div class="file-upload-label">Файл:</div>
            <button type="button">Выберите файл</button>
            <div v-text="fileName"></div>
            <input
              type="file"
              :accept="accept"
              name="file"
              ref="file"
              @change="changeFile"
            />
          </div>
          <div v-if="errorText" class="alert alert-danger">{{ errorText }}</div>
          <div v-show="typeIndex >= 0 && docs[typeIndex].IS_ECP_REQ">
            Файл требует обязательной подписи!
          </div>
          <div
            v-for="(err, indexErr) in errorArr"
            :key="indexErr"
            class="alert alert-danger"
            style="margin-top: 10px"
          >
            {{ err.TEXT }}
          </div>
          <div class="foot-butt center-block" style="text-align: center">
            <button type="button" class="b-o" @click="showUploader = false">
              Отмена
            </button>
            <button
              v-if="ecpAvailable && typeIndex >= 0"
              type="button"
              @click="startECP()"
              class="b-l"
            >
              Подписать
            </button>
            <button
              type="submit"
              class="b-l"
              v-show="uploadAvailable"
              :disabled="!uploadAvailable"
            >
              Загрузить
            </button>
          </div>
        </form>
      </div>
      <div class="window-doc" v-show="showECP">
        <h3>ПОДПИСЬ ДОКУМЕНТА</h3>
        <div v-if="!ecpPluginEnabled" style="color: red;text-align: center">
          Плагин не активен
        </div>
        <div v-else style="color: green;text-align: center">
          Плагин загружен.
        </div>
        <br />
        <form action="#" @submit.prevent="submit" class="load-doc">
          <div>
            <strong>Укажите сертификат подписи</strong>
          </div>
          <select
            v-model="ecpCert"
            class="i-style i-style-sel"
            style="width: 555px;"
          >
            <option
              v-for="(cert, certIndex) in ecpCerts"
              :value="cert"
              :key="certIndex"
              >{{ limitStingSize(cert.text, 240) }}
            </option>
          </select>
          <br />
          <br />
          <div>
            <a :href="siteUrl + 'methods/doc/Инструкция_ЭЦП.pdf'"
              >Инструкция по установке ЭЦП</a
            >
            <br />КриптоПро ЭЦП Browser plug-in
            <a href="https://www.cryptopro.ru/products/cades/plugin/get_2_0"
              >скачать</a
            >
          </div>
          <div class="foot-butt center-block" style="text-align: center">
            <button type="button" class="b-o" @click="showUploader = false">
              Отмена
            </button>
            <button
              type="button"
              :disabled="ecpCert === null"
              @click="Common_SignCadesBES_File()"
              class="b-l"
            >
              Подписать
            </button>
          </div>
        </form>
      </div>
    </div>
  </td>
</template>

<script>
/*global cadesplugin*/
import { MonitoringLizingOrgs } from "@/common/api.service";
import { mapGetters } from "vuex";
import "@/scripts/cadesplugin_api";
import { AUTH_URL } from "@/common/config";

export default {
  name: "MloUpload",
  props: [
    "docs",
    // "project",
    "subIndex"
  ],
  data() {
    return {
      fileForm: {
        TYPE_ID: 0,
        file: "",
        EXPERTISE_ID: 0
      },
      errorText: "",
      showUploader: false,
      typeIndex: -1,
      docName: "",
      file: "",
      fileName: "Файл не выбран",
      accept: "",
      showECP: false,
      ecpPluginEnabled: false,
      ecpCerts: [],
      ecpValue: "",
      ecpCert: null,
      ecpEnsurer: "",
      fileBase64: "",
      siteUrl: "",
      errorArr: []
    };
  },
  mounted() {
    this.bindChange();
    this.siteUrl = AUTH_URL;
  },
  computed: {
    uploadAvailable() {
      if (this.fileName === "Файл не выбран") {
        return false;
      }
      if (this.typeIndex < 0) {
        return false;
      }
      if (this.docs[this.typeIndex].IS_MULTIPLY && this.docName === "") {
        return false;
      }
      if (this.docs[this.typeIndex].UF_IS_ECP_REQ && !this.ecpValue) {
        return false;
      }

      return true;
    },
    ecpAvailable() {
      if (this.typeIndex < 0) {
        return false;
      }
      if (this.docs[this.typeIndex].UF_IS_ECP_REQ) {
        return true;
      }

      return false;
    },
    ...mapGetters(["currentUser"])
  },
  methods: {
    sUploader() {
      this.showUploader = !this.showUploader;
      this.typeIndex = this.subIndex ? this.subIndex : -1;
      this.docName = "";
      this.file = "";
      this.fileName = "Файл не выбран";
      this.showECP = false;
      this.ecpPluginEnabled = false;
      this.ecpCerts = [];
      this.ecpValue = "";
      this.ecpEnsurer = "";
      this.fileBase64 = "";
      this.errorArr = [];
      this.errorText = "";
    },
    startECP() {
      this.showECP = true;
      this.Common_CheckForPlugIn();
    },
    Common_CheckForPlugIn() {
      cadesplugin.set_log_level(cadesplugin.LOG_LEVEL_DEBUG);
      let canAsync = !!cadesplugin.CreateObjectAsync;
      if (canAsync) {
        return this.CheckForPlugIn_Async();
      } else {
        //return CheckForPlugIn_NPAPI();
      }
    },
    CheckForPlugIn_Async() {
      this.ecpPluginEnabled = true;
      let _this = this;
      cadesplugin.async_spawn(function*() {
        //let oAbout = yield cadesplugin.CreateObjectAsync("CAdESCOM.About");
        yield _this.FillCertList_Async();
      });
    },
    /*updateDocInfo() {
      MonitoringLizingOrgs.getDocumentESProjects(this.$route.params.id).then(
        ({ data }) => {
          console.log("getDocumentESProjects", data);
          // this.documentConf.FILE_LOAD_INFO = data.FILE_LOAD_INFO;
          // this.documentConf.FILE_ACCEPT_INFO = data.FILE_ACCEPT_INFO;
          // this.documentConf.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH;
          // this.documentConf.LIST_TYPE = data.LIST_TYPE;
        },
        this
      );
    },*/
    FillCertList_Async() {
      let _this = this;
      cadesplugin.async_spawn(function*() {
        let oStore;
        try {
          oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
          if (!oStore) {
            alert("Ошибка чтения сертификатов ЭЦП");
            return;
          }

          yield oStore.Open();
        } catch (ex) {
          alert("Ошибка чтения сертификатов ЭЦП");
        }

        let CertificatesObj = yield oStore.Certificates;

        let certCnt = yield CertificatesObj.Count;
        if (certCnt == 0) {
          throw "Сертификаты не найдены";
        }

        try {
          yield oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
          let certs = yield oStore.Certificates;
          let certCnt = yield certs.Count;
          for (let i = 1; i <= certCnt; i++) {
            let cert = yield certs.Item(i);

            let oOpt = {
              text: "",
              value: ""
            };
            oOpt.text = yield cert.SubjectName;
            oOpt.value = yield cert.Thumbprint;
            console.log("ceeert", oOpt);
            _this.ecpCerts.push(oOpt);
          }
          yield oStore.Close();
        } catch (ex) {
          console.log(ex);
        }
      });
    },
    Common_SignCadesBES_File() {
      let canAsync = !!cadesplugin.CreateObjectAsync;
      if (canAsync) {
        return this.SignCadesBES_Async_File();
      } else {
        // return SignCadesBES_NPAPI_File(id);
      }
    },
    SignCadesBES_Async_File() {
      let _this = this;
      cadesplugin.async_spawn(function*() {
        try {
          //FillCertInfo_Async(certificate);
          let oSigner;
          let errormes = "";
          try {
            oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
          } catch (err) {
            errormes = "Failed to create CAdESCOM.CPSigner: " + err.number;
            throw errormes;
          }
          let oSigningTimeAttr = yield cadesplugin.CreateObjectAsync(
            "CADESCOM.CPAttribute"
          );

          let CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
          yield oSigningTimeAttr.propset_Name(
            CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME
          );
          let oTimeNow = new Date();
          yield oSigningTimeAttr.propset_Value(oTimeNow);
          let attr = yield oSigner.AuthenticatedAttributes2;
          yield attr.Add(oSigningTimeAttr);

          let oDocumentNameAttr = yield cadesplugin.CreateObjectAsync(
            "CADESCOM.CPAttribute"
          );
          let CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1;
          yield oDocumentNameAttr.propset_Name(
            CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME
          );
          yield oDocumentNameAttr.propset_Value("Document Name");
          yield attr.Add(oDocumentNameAttr);

          let oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
          try {
            oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
          } catch (e) {
            alert("Ошибка при открытии хранилища");
            console.log(e);
            return;
          }

          let CertificatesObj = yield oStore.Certificates;
          let CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0;
          let oCerts = yield CertificatesObj.Find(
            CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
            _this.ecpCert.value
          );

          if (oCerts.Count == 0) {
            errormes = "Certs not found";
            throw errormes;
          }

          let oCert = yield oCerts.Item(1);
          let sName = yield oCert.SubjectName;

          if (oSigner) {
            yield oSigner.propset_Certificate(oCert);
          } else {
            errormes = "Failed to create CAdESCOM.CPSigner";
            throw errormes;
          }

          let oSignedData = yield cadesplugin.CreateObjectAsync(
            "CAdESCOM.CadesSignedData"
          );
          let CADES_BES = 1;
          let dataToSign = _this.fileBase64;
          if (dataToSign) {
            yield oSignedData.propset_ContentEncoding(1); //CADESCOM_BASE64_TO_BINARY
            yield oSignedData.propset_Content(dataToSign);
            yield oSigner.propset_Options(1); //CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN
            try {
              _this.ecpValue = yield oSignedData.SignCades(oSigner, CADES_BES);
              _this.showECP = false;
              let sn = sName.split(",");
              sn.forEach(function(v) {
                let r = v.replace("CN=", "");
                if (r.length !== v.length) {
                  _this.ecpEnsurer = r.trim();
                }
              });
            } catch (err) {
              throw err;
            }
          }
          //alert(Signature)
        } catch (err) {
          console.log("sign err", err);
          alert(`У сертификата подписи: ${err.message}`);
        }
      });
    },
    bindChange() {
      if (this.typeIndex < 0) {
        return;
      }
      // let types = this.docs[this.typeIndex].EXT.split(";");
      this.file = "";
      this.fileName = "Файл не выбран";
      this.ecpCert = null;
      this.ecpValue = "";
      this.errorText = "";
      this.accept = "";
      // this.accept = "." + types.join(",.");
    },
    submit() {
      if (typeof this.$refs.file.files[0] === "undefined") {
        return false;
      }

      let formData = new FormData();
      if (this.docs[this.typeIndex].FILE_INFO["ID"] > 0) {
        formData.append("ID", this.docs[this.typeIndex].FILE_INFO["ID"]);
      }

      formData.append("FILE", this.$refs.file.files[0]);
      formData.append("UF_COMPANY_ID", this.docs[this.typeIndex].UF_COMPANY_ID);
      formData.append(
        "UF_LIZING_TYPE_DOCUMENTS_ID",
        this.docs[this.typeIndex].UF_LIZING_TYPE_DOCUMENTS_ID
      );
      formData.append("UF_YEAR", this.docs[this.typeIndex].UF_YEAR);
      formData.append(
        "UF_TYPE_PERIOD_REPORTING_ID",
        this.docs[this.typeIndex].UF_TYPE_PERIOD_REPORTING_ID
      );

      if (this.docs[this.typeIndex].UF_IS_ECP_REQ) {
        formData.append("UF_FILE_SIGN_ECP", this.ecpValue);
        formData.append("UF_FILE_SIGN_AUTHOR", this.ecpEnsurer);
      }

      MonitoringLizingOrgs.saveDocument(formData, this.fileForm).then(
        response => {
          console.log(response);
          if (!response.data.error) {
            this.$parent.fetchList();
            this.showUploader = false;
          } else {
            this.errorArr = response.data.errorArr;
          }
        },
        this
      );
      return false;
    },
    changeFile() {
      let reader = new FileReader();
      this.ecpValue = "";
      this.ecpCert = "";
      (this.errorText = ""), reader.readAsDataURL(this.$refs.file.files[0]);
      reader.onload = () => {
        let file = this.$refs.file.files[0];
        if (file.size < 1024 * 1024 * 25) {
          let header = ";base64,";
          let fileData = reader.result;

          this.fileBase64 = fileData.substr(
            fileData.indexOf(header) + header.length
          );
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 25 Мб";
        }
      };
      this.fileName = this.$refs.file.files[0].name;
    },
    stripTags(str) {
      str = str.toString();
      return str.replace(/<\/?[^>]+>/gi, "");
    },
    limitStingSize(value, size) {
      if (!value) return "";
      value = value.toString();

      if (value.length <= size) {
        return value;
      }
      return value.substr(0, size) + "...";
    }
  }
};
</script>

<style scoped></style>
